export default {
  title: '登錄 / 註冊',
  subtitle: '手機 / 郵箱驗證即登錄，新用戶自動創建賬號',
  tabUsername: '用戶名',
  tabEmail: '郵箱',
  tabPhone: '手機號',
  usernamePlaceholder: '請輸入用戶名',
  emailPlaceholder: '請輸入郵箱',
  phonePlaceholder: '請輸入手機號',
  passwordLabel: '密碼',
  passwordPlaceholder: '請輸入密碼',
  verifyCode: '驗證碼',
  emailCodePlaceholder: '郵箱驗證碼',
  smsCodePlaceholder: '短信驗證碼',
  getCode: '獲取驗證碼',
  rememberMe: '記住我',
  forgotPassword: '忘記密碼?',
  submit: '登錄 / 註冊',
  loading: '登錄中...',
  loginSuccess: '登錄成功，正在進入...',
  quickLogin: '快捷登錄 / 註冊',
  socialUnavailable: '該登錄方式暫未開放',
  metamaskNotInstalled: '未檢測到 MetaMask，請先安裝錢包插件',
  metamaskRejected: '已取消錢包授權 / 簽名',
  metamaskConnectFailed: '錢包連接失敗，請重試',
  metamaskRequestPending: '請在 MetaMask 彈窗中確認授權，或取消後重試',
  metamaskAccountChanged: '錢包賬號已切換，請重新發起登錄',
  metamaskRateLimited: '操作太頻繁，請稍後再試',
  metamaskBanned: '賬號已被禁用，請聯繫客服',
  agreementPrefix: '登錄即代表同意',
  userAgreement: '《用戶協議》',
  and: '與',
  privacyPolicy: '《隱私政策》',
  agreementSuffix: '，且已滿18週歲',
  forgotTitle: '找回登錄密碼',
  forgotSubtitle: '僅用戶名賬號需找回;先驗證已綁定的手機 / 郵箱',
  accountLabel: '賬號(用戶名)',
  accountPlaceholder: '輸入註冊用戶名',
  boundContactLabel: '已綁定手機 / 郵箱',
  boundContactPlaceholder: '輸入綁定的手機號（含區號，如 +86）或郵箱',
  sixDigitCodePlaceholder: '6 位驗證碼',
  nextStep: '下一步',
  newPasswordLabel: '新登錄密碼',
  newPasswordPlaceholder: '8-64 位,含字母與數字',
  confirmPasswordLabel: '確認新密碼',
  confirmPasswordPlaceholder: '再次輸入新密碼',
  confirmReset: '確認重置',
  resetSuccess: '密碼重設成功，請重新登錄',
  rememberedText: '想起來了?',
  backToLogin: '返回登錄',
  errorUsernameRequired: '請輸入用戶名',
  errorUsernameInvalid: '用戶名需為 4-20 位字母、數字或下劃線',
  errorPasswordLetterDigit: '密碼必須同時包含字母和數字',
  errorEmailInvalid: '請輸入正確的郵箱地址',
  errorEmailCodeRequired: '請輸入 6 位郵箱驗證碼(錯誤示例:驗證碼不正確)',
  errorPhoneInvalid: '請輸入正確的手機號',
  errorPhoneCodeRequired: '請輸入 6 位短信驗證碼',
  errorPasswordRequired: '請輸入密碼',
  errorPasswordLength: '密碼長度需為 8-64 位',
  errorPasswordTooShort: '密碼至少 6 位',
  errorAgreementRequired: '請同意用戶協議',
  errorContactRequired: '請輸入正確的綁定手機號（含區號）或郵箱',
  errorLoginFailed: '登錄失敗，請稍後重試',
  errorNetwork: '網絡連接失敗，請檢查網絡後重試',
  errorNewPasswordRequired: '新密碼須為 8–64 位且含字母與數字',
  errorNewPasswordInvalid: '密碼需為 8-64 位，含字母與數字',
  errorConfirmPasswordMismatch: '兩次輸入的密碼不一致',
  errorResetFailed: '重置密碼失敗，請稍後重試',
  codeSendLimited: '驗證碼發送次數已達上限，請 10 分鐘後再試',
}
